// extracted by mini-css-extract-plugin
module.exports = {"morefrom_toi":"hokhq","col1":"HxPq6","col2":"pt28S","quicklink":"Ox45p"};